






















































































































import Api from '@/base/api.typings';
import Vue from 'vue';
import Component from 'vue-class-component';
import empresaAtualService from '../empresa-atual/empresa-atual-service';
import financeiroService from './financeiro-service';

interface ImportarFinanceiroDTO
    extends Api.App.Server.Financeiro.Importar.FinanceiroDTO {}

interface FinanceiroDTO
    extends Api.App.Server.Financeiro.InserirEditar.FinanceiroDto {}

enum abaEnum {
    valido = 0,
    invalido = 1,
}

Vue.filter('parseList', function(string) {
    if (string == null || string.length == 0) {
        return '';
    }

    return string.join(' / ');
});

@Component
export default class FinanceiroImportar extends Vue {
    file: any;
    fileName: string = '';
    importado: boolean = false;
    dadosValidos: ImportarFinanceiroDTO[] = [];
    dadosInvalidos: ImportarFinanceiroDTO[] = [];
    dadosAba: ImportarFinanceiroDTO[] = [];
    aba: number = 0;
    mostrarValoresOpcionais: boolean = false;
    abaFalhas: boolean = false;
    empresaId: string = '';

    selectFile(file) {
        if (file == null) {
            this.fileName = '';
        } else {
            this.fileName = file.name;
        }

        this.file = file;
    }

    async importar() {
        this.empresaId = await empresaAtualService.obterEmpresaAtualId();

        let formData = new FormData();
        formData.append('name', this.fileName);
        formData.append('file', this.file);
        formData.append('empresaId', this.empresaId);

        this.$action.processAction({
            action: async () => {
                const resultado = await financeiroService.importar(
                    formData
                );

                if (resultado) {
                    const dados = resultado.itens;
                    this.dadosValidos = dados.filter(
                        (f) => !f.erros || f.erros.length == 0
                    );

                    this.dadosInvalidos = dados.filter(
                        (f) => f.erros && f.erros.length > 0
                    );

                    this.listar();
                }

                this.importado = true;
            },
            showSnackbar: false,
        });
    }

    async confirmarImportar() {
        const itens: FinanceiroDTO[] = this.dadosValidos.map((item) => {
            let result: FinanceiroDTO = {
                codigoPrestador: item.codigoPrestador,
                codigoCliente: item.codigoCliente,
                ano: item.ano,
                mes: item.mes,
                faturamento: item.faturamento,
                despesas: item.despesas,
            };

            if (this.mostrarValoresOpcionais) {
                result.aliquotaEfetivaSimples = item.aliquotaEfetivaSimples;
                result.valorDas = item.valorDas;
            }

            return result;
        });

        let registrosInseridos = 0;
        if (itens && itens.length > 0) {
            this.$action.processAction({
                action: async () => {
                    registrosInseridos = await financeiroService.inserirEditar(
                        {
                            arquivoNome: this.fileName,
                            empresaId: this.empresaId,
                            itens,
                        }
                    );

                    let text = `${registrosInseridos} registros foram importados com sucesso`;
                    if (registrosInseridos == 0) {
                        text = 'Nenhum registro foi importado';
                    }

                    this.$snackbars.open({
                        text,
                        color: 'success',
                    });

                    this.importado = false;

                    this.refresh();
                },
                showSnackbar: false,
            });
        } else {
            this.$snackbars.open({
                text: 'Não existem registros válidos para importação',
                color: 'success',
            });
        }
    }

    refresh() {
        this.dadosValidos = [];
        this.dadosInvalidos = [];
        this.listar();
    }

    listar() {
        if (this.aba == abaEnum.valido) {
            this.dadosAba = this.dadosValidos;
        } else {
            this.dadosAba = this.dadosInvalidos;
        }

        this.abaFalhas = this.aba == abaEnum.invalido;
        this.mostrarValoresOpcionais =
            this.dadosAba &&
            this.dadosAba.length > 0 &&
            this.dadosAba[0].valorDas != null;
    }
}
